import * as THREE from 'three';
import * as marietta3d from '..';
import { ThreeView } from "./View3dWebCad";
import { CanvasInfo } from '../base/index';

export class MeasureTool {

    public invalidate = true;       // 動作無効フラグ　trueで無効
    private clickpoints: THREE.Vector3[] = [];
    // コンストラクタ
	constructor() {
        this.initMeasureTool();
    }

    public measureMode() {
        this.invalidate = false;   //有効

        const mesureInfo = document.getElementById('mesureInfo');
        if (mesureInfo) {
            mesureInfo.style.display = 'block';
        }

        const measureg = marietta3d.webcad.ThreeView.get().wcScene.me.getObjectByName('MeasureTool');
        
        if (!measureg) return;

        while (measureg.children.length > 0) {
            measureg.remove(measureg.children[0]);
        }
    }

    public resetTool() {
        ThreeView.get().selectManager.invalidate = false;   // 選択
        this.invalidate = true;                             // 無効
        
        this.clickpoints = [];
    }

    private initMeasureTool() {
        const hideTool = () => {
            const div = document.getElementById(`MeasureTool`);
            if (div) {
                div.style.visibility = 'hidden';
            }
            removeObject();
        };

        const removeObject = () => {
            const measureg = marietta3d.webcad.ThreeView.get().wcScene.me.getObjectByName('MeasureTool');
            if (!measureg) return;

            while (measureg.children.length > 0) {
                measureg.remove(measureg.children[0]);
            }
        };

        document.addEventListener('mousedown', () => {
            console.log("mousedown");

            hideTool();
        });
        document.addEventListener('wheel', () => {
            console.log("wheel");

            hideTool();
        });
        
        const pointer = (e: MouseEvent) => {
            const element = e.currentTarget as HTMLElement;
            // canvas要素上のXY座標
            // canvas要素の幅・高さ
              const rect = element.getBoundingClientRect();
              const x = e.clientX - rect.left;
              const y = e.clientY - rect.top;
              const w = rect.width;
              const h = rect.height;
  
            // -1〜+1の範囲で現在のマウス座標を登録する
            const pointer = new THREE.Vector2();
            pointer.x = (x / w) * 2 - 1;
            pointer.y = -(y / h) * 2 + 1;
            return pointer;
        }
  
        marietta3d.webcad.ThreeView.get().container.addEventListener('click', (e: MouseEvent) => pickup(e));

        const initRayCaster = new THREE.Raycaster();
        const group: THREE.Mesh[] = [];
        marietta3d.webcad.ThreeView.get().wcScene.me.traverse((object: THREE.Object3D) => {
            const mesh = <THREE.Mesh>object;
            if (!mesh.isMesh) return;
            group.push(mesh);
        });
  
        this.clickpoints = [];

        const createSphere = (point: THREE.Vector3) => {
            const geometry = new THREE.SphereGeometry( 0.015, 32, 16 );
            const material = new THREE.MeshBasicMaterial( { color: 0x006000 } );
            const sphere = new THREE.Mesh( geometry, material );
            sphere.position.set(point.x, point.y, point.z);
            const mesureG = marietta3d.webcad.ThreeView.get().wcScene.me.getObjectByName('MeasureTool');
            mesureG.add(sphere);
        }

        const createLine = (points: THREE.Vector3[]) => {
            const geometry = new THREE.BufferGeometry().setFromPoints(points);
            const material = new THREE.LineBasicMaterial({ color: 0x006000 });
            
            const line = new THREE.Line(geometry, material);
            const mesureG = marietta3d.webcad.ThreeView.get().wcScene.me.getObjectByName('MeasureTool');
            mesureG.add(line);
        }

        const createGroup = () => {
            const group = new THREE.Group();
            group.name = 'MeasureTool';

            ThreeView.get().wcItemmgr.addOtherShapes(group);
        }

        const hasMesure = (): boolean => {
            return (marietta3d.webcad.ThreeView.get().wcScene.me.getObjectByName('MeasureTool') != undefined);
        }
  
        const pickup = (e: MouseEvent) => {
            if (this.invalidate == true) return;

            initRayCaster.setFromCamera(pointer(e), ThreeView.get().wcCameras.camera.me);
            const intersects = initRayCaster.intersectObjects(group, true);

            if (!hasMesure()) {
                createGroup();
            }

            if (intersects.length <= 0) return;
  
            const point = intersects[0].point;
  
            createSphere(point);
            
            this.clickpoints.push(point);

            if (this.clickpoints.length == 1) return;
            
            createSphere(this.clickpoints[0]);
            createLine(this.clickpoints);
            
            ThreeView.get().selectManager.invalidate = false;   // 選択
            this.invalidate = true;                             // 無効
            this.createDiv();
            this.measurePosition(this.clickpoints);

            const mesureInfo = document.getElementById('mesureInfo');
            if (mesureInfo) {
                mesureInfo.style.display = 'none';
            }

            this.clickpoints = [];
        }
    }

    // divタグの作成
    private createDiv = () => {
        if (document.getElementById('MeasureTool')) return;

        const div = document.createElement('div');
        div.id = `MeasureTool`;
        div.style.position = 'absolute';

        const elm = document.getElementById('webcad3dView');
        elm.appendChild(div);
        div.style.visibility = 'hidden';
    }

    // three.jsのviewでのスクリーン座標
    private screenPosition(pos: THREE.Vector3) {
        const size = CanvasInfo.get().size;

        const camera = <THREE.PerspectiveCamera>ThreeView.get().cameras.camera.me;
        // スクリーン座標を取得する
        const projection = pos.project(camera);

        const sx = (size.x / 2) * (+projection.x + 1.0);
        const sy = (size.y / 2) * (-projection.y + 1.0);
        return { x: sx, y: sy };
    }

    private measurePosition(clickpoints: THREE.Vector3[]) {
        const labelPosition = clickpoints[0].clone().add(clickpoints[1].clone().sub(clickpoints[0]).multiplyScalar(0.5));
        const distance = clickpoints[1].distanceTo(clickpoints[0])
        const div = document.getElementById(`MeasureTool`);
        div.style.visibility = 'visible';
        const dist = 100;
        div.innerHTML = `${Math.floor(distance * 1000)}mm`;

        const pos = this.screenPosition(labelPosition.clone());

        div.style.top = `0px`
        div.style.left = `8px`;
        div.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';

        div.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
    }
}